import { render, staticRenderFns } from "./change-datafile-ownership.vue?vue&type=template&id=dadba1f8"
import script from "./change-datafile-ownership.vue?vue&type=script&lang=js"
export * from "./change-datafile-ownership.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports